var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEscoamentoBanheiro = function SvgEscoamentoBanheiro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6V8H15C16.1046 8 17 8.89543 17 10V16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16V10C7 8.89543 7.89543 8 9 8H10V6H14ZM3 9C3.55228 9 4 9.44772 4 10V11H6V15H4V16C4 16.5523 3.55228 17 3 17C2.44772 17 2 16.5523 2 16V10C2 9.44772 2.44772 9 3 9ZM21 9C21.5523 9 22 9.44772 22 10V16C22 16.5523 21.5523 17 21 17C20.4477 17 20 16.5523 20 16V15H18V11H20V10C20 9.44772 20.4477 9 21 9ZM15 4C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H9C8.44772 6 8 5.55228 8 5C8 4.44772 8.44772 4 9 4H15Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEscoamentoBanheiro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/escoamento-banheiro.d87e632c.svg";
export { ForwardRef as ReactComponent };